
import React from 'react';
import { CostBreakdown } from '../types.ts';
import CostBreakdownDisplay from './CostBreakdownDisplay.tsx';

interface CostDetailModalProps {
  breakdown: CostBreakdown;
  onClose: () => void;
}

const CostDetailModal: React.FC<CostDetailModalProps> = ({ breakdown, onClose }) => {
  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center border-b pb-3 mb-4">
            <h2 className="text-2xl font-bold text-gray-800">Dettaglio Costo: <span className="text-sky-600">{breakdown.articleName}</span></h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                <i className="fas fa-times fa-lg"></i>
            </button>
        </div>
        
        <CostBreakdownDisplay breakdown={breakdown} />

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-sky-600 text-white rounded-md hover:bg-sky-700 shadow-md"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

export default CostDetailModal;
